// import React, { useEffect, useState } from "react";

// const Gallery = () => {
//   const [images, setImages] = useState([]);
//   const [selected, setSelected] = useState(null);
//   const [filter, setFilter] = useState("all");

//   // 🔐 Admin check
//   const isAdmin = localStorage.getItem("isAdmin");

//   // ✏️ Edit states
//   const [editIndex, setEditIndex] = useState(null);
//   const [editFile, setEditFile] = useState(null);

//   useEffect(() => {
//     const stored = JSON.parse(localStorage.getItem("gallery")) || [];
//     setImages(stored);
//   }, []);

//   // ❌ DELETE (ADMIN ONLY)
//   const handleDelete = (index) => {
//     const updated = images.filter((_, i) => i !== index);
//     setImages(updated);
//     localStorage.setItem("gallery", JSON.stringify(updated));
//   };

//   // ✏️ UPDATE IMAGE (ADMIN ONLY)
//   const handleEdit = () => {
//     if (!editFile || editIndex === null) return;

//     const reader = new FileReader();

//     reader.onloadend = () => {
//       const updated = [...images];

//       updated[editIndex] = {
//         ...updated[editIndex],
//         url: reader.result
//       };

//       setImages(updated);
//       localStorage.setItem("gallery", JSON.stringify(updated));

//       setEditFile(null);
//       setEditIndex(null);

//       alert("✏️ Image Updated!");
//     };

//     reader.readAsDataURL(editFile);
//   };

//   // 📂 FILTER
//   const filteredImages =
//     filter === "all"
//       ? images
//       : images.filter((img) => img.category === filter);

//   return (
//     <div className="gallery-section">
//       <h2>Our Work</h2>

//       {/* 📂 CATEGORY FILTER */}
//       <div style={{ marginBottom: "20px" }}>
//         <button onClick={() => setFilter("all")}>All</button>
//         <button onClick={() => setFilter("car")}>🚗 Car</button>
//         <button onClick={() => setFilter("wedding")}>💍 Wedding</button>
//         <button onClick={() => setFilter("puja")}>🪔 Puja</button>
//       </div>

//       <div className="gallery-grid">
//         {filteredImages.length === 0 && (
//           <p>No images uploaded yet</p>
//         )}

//         {filteredImages.map((img, index) => (
//           <div key={index} style={{ position: "relative" }}>
            
//             {/* 🖼 IMAGE */}
//             <img
//               src={img.url}
//               alt="gallery"
//               onClick={() => setSelected(img.url)}
//             />

//             {/* ❌ DELETE (ADMIN ONLY) */}
//             {isAdmin && (
//               <button
//                 onClick={() => handleDelete(index)}
//                 style={{
//                   position: "absolute",
//                   top: "5px",
//                   right: "5px",
//                   background: "red",
//                   color: "white",
//                   border: "none",
//                   borderRadius: "50%",
//                   cursor: "pointer"
//                 }}
//               >
//                 ✖
//               </button>
//             )}

//             {/* ✏️ EDIT (ADMIN ONLY) */}
//             {isAdmin && (
//               <>
//                 <button
//                   onClick={() => setEditIndex(index)}
//                   style={{
//                     position: "absolute",
//                     bottom: "5px",
//                     left: "5px",
//                     background: "orange",
//                     color: "white",
//                     border: "none",
//                     borderRadius: "5px",
//                     cursor: "pointer"
//                   }}
//                 >
//                   ✏️
//                 </button>

//                 {editIndex === index && (
//                   <div style={{ marginTop: "5px" }}>
//                     <input
//                       type="file"
//                       onChange={(e) => setEditFile(e.target.files[0])}
//                     />

//                     <button onClick={handleEdit}>
//                       Update
//                     </button>
//                   </div>
//                 )}
//               </>
//             )}
//           </div>
//         ))}
//       </div>

//       {/* 🔍 POPUP VIEW */}
//       {selected && (
//         <div
//           onClick={() => setSelected(null)}
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             background: "rgba(0,0,0,0.8)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center"
//           }}
//         >
//           <img
//             src={selected}
//             alt="popup"
//             style={{ maxWidth: "90%", maxHeight: "90%" }}
//           />
//         </div>
//       )}
//     </div>
//   );
// };

// export default Gallery;







// for static now
import React, { useState } from "react";

// import images
import car1 from "../assets/car1.jpg";
import car2 from "../assets/car2.jpg";
import car3 from "../assets/car3.jpg";
import car4 from "../assets/car4.jpg";
import wedding1 from "../assets/image2.jpg";
import wedding2 from "../assets/image3.jpg";
import busket from "../assets/Busket1.webp"
import rajaniStick from "../assets/rajanigandha-stick.png";
import gandhaMala from "../assets/gandha-mala.jpg";
import jobaMala from "../assets/joba mala.jpg";
import rajaniMala from "../assets/rajani-mala.jpg";
import roseMala from "../assets/rose-mala.png";
import aparajitaMala from "../assets/Aparajita-mala.webp";
import sunflower from "../assets/sunflower.jpeg";
import zerbera from "../assets/zerbera.jpg";
import busket2 from "../assets/busket2.jfif";
import busket3 from "../assets/busket3.jpg";
import busket4 from "../assets/busket4.jfif";

import roseMala2 from "../assets/rose-mala2.webp";
import roseMala3 from "../assets/rose-mala3.jpg";

import rajaniPadma from "../assets/rajani-padma-mala.webp";
import rajaniPapdi from "../assets/rajani-papdi-mala.webp";

import joba from "../assets/joba.jpg";
const Gallery = () => {
  const [selected, setSelected] = useState(null);
  const [filter, setFilter] = useState("all");

  // ✅ STATIC IMAGES
  const images = [
  // car
  { url: car1, category: "car" },
  { url: car2, category: "car" },
  { url: car3, category: "car" },
  { url: car4, category: "car" },

  // wedding
  { url: wedding1, category: "wedding" },
  { url: wedding2, category: "wedding" },

  // basket
  { url: busket, category: "wedding" },
  { url: busket2, category: "wedding" },
  { url: busket3, category: "wedding" },
  { url: busket4, category: "wedding" },

  // puja mala
  { url: rajaniStick, category: "puja" },
  { url: gandhaMala, category: "puja" },
  { url: jobaMala, category: "puja" },
  { url: rajaniMala, category: "puja" },
  { url: aparajitaMala, category: "puja" },

  { url: rajaniPadma, category: "puja" },
  { url: rajaniPapdi, category: "puja" },

  // rose mala
  { url: roseMala, category: "puja" },
  { url: roseMala2, category: "wedding" },
  { url: roseMala3, category: "wedding" },

  // flowers
  { url: sunflower, category: "puja" },
  { url: zerbera, category: "wedding" },
  { url: joba, category: "puja" }
];

  const filteredImages =
    filter === "all"
      ? images
      : images.filter((img) => img.category === filter);

  return (
    <div className="gallery-section">
      <h2>Our Work</h2>

      <div style={{ marginBottom: "20px" }}>
        <button onClick={() => setFilter("all")}>All</button>
        <button onClick={() => setFilter("car")}>🚗 Car</button>
        <button onClick={() => setFilter("wedding")}>💍 Wedding</button>
        <button onClick={() => setFilter("puja")}>🪔 Puja</button>
      </div>

      <div className="gallery-grid">
        {filteredImages.map((img, index) => (
          <img
            key={index}
            src={img.url}
            alt="gallery"
            onClick={() => setSelected(img.url)}
          />
        ))}
      </div>

      {selected && (
        <div
          onClick={() => setSelected(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <img
            src={selected}
            alt="popup"
            style={{ maxWidth: "90%", maxHeight: "90%" }}
          />
        </div>
      )}
    </div>
  );
};

export default Gallery;